import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import {appName} from "../../../Components/constants/default";

const Footer = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <footer className="custom-footer bg-dark py-5 position-relative" role="contentinfo">
                <Container>
                    <Row className="text-center text-sm-start align-items-center mt-5">
                        <Col sm={6}>
                            <div>
                                <p className="copy-rights mb-0">
                                    <span itemProp="copyrightYear">{new Date().getFullYear()}</span> © {appName}.
                                    Designed & developed by <span itemProp="author">T-code Tomasz Hliwiadczyn</span>
                                </p>
                            </div>
                        </Col>
                        <Col sm={6}>
                            <nav className="text-sm-end mt-3 mt-sm-0" aria-label={t('landing.footer.footerNav')}>
                              <ul className="list-inline mb-0 footer-social-link">
                                <li className="list-inline-item pe-3">
                                    <Link to="/privacy-policy" title={t('landing.footer.privacyPolicyTitle')}>
                                        {t('landing.footer.privacyPolicy')}
                                    </Link>
                                </li>
                                <li className="list-inline-item">
                                  <a
                                      href="mailto:tomasz.hliwiadczyn@gmail.com"
                                      className="avatar-xs d-block"
                                      title={t('landing.footer.emailTitle')}
                                      aria-label={t('landing.footer.emailAriaLabel')}
                                  >
                                    <div className="avatar-title rounded-circle">
                                      <i className="ri-google-fill" aria-hidden="true"></i>
                                    </div>
                                  </a>
                                </li>
                                <li className="list-inline-item">
                                  <a
                                      href="https://facebook.com/zagrajmi"
                                      className="avatar-xs d-block"
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      title={t('landing.footer.facebookTitle')}
                                      aria-label={t('landing.footer.facebookAriaLabel')}
                                  >
                                    <div className="avatar-title rounded-circle">
                                      <i className="ri-facebook-fill" aria-hidden="true"></i>
                                    </div>
                                  </a>
                                </li>
                              </ul>
                            </nav>
                        </Col>
                    </Row>
                </Container>
            </footer>
        </React.Fragment >
    );
};

export default Footer;
